import Keycloak from 'keycloak-js';

import { config } from './config.js';

/**
 * Keycloak-Instanz des Frontends. Werte stammen aus `window.__CIVIPORT_CONFIG__`
 * (Runtime-Config) bzw. den Defaults aus `./config.ts`.
 */
export const keycloak = new Keycloak({
  url: config.keycloakUrl,
  realm: config.realm,
  clientId: config.clientId,
});

export const keycloakInitOptions = {
  onLoad: 'login-required' as const,
  pkceMethod: 'S256' as const,
  checkLoginIframe: false,
};
